import { forwardRef, createElement } from 'react';

function IconWebshop(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M11 15.5a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm5.831 0a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zM11 17a.75.75 0 100 1.5.75.75 0 000-1.5zm5.831 0a.75.75 0 100 1.5.75.75 0 000-1.5zM5.287 4a1.75 1.75 0 011.56.955l.062.138 3.24 8a.25.25 0 00.173.15l.06.007h7.743a.25.25 0 00.204-.105l.028-.054 2.159-5.496a.25.25 0 00-.141-.324l-.045-.013-.047-.005-10.04-.003a.75.75 0 01-.102-1.493l.102-.007 10.04.003A1.75 1.75 0 0121.962 8l-.049.143-2.158 5.497a1.75 1.75 0 01-1.476 1.103l-.153.007h-7.743a1.75 1.75 0 01-1.56-.955l-.062-.138-3.24-8a.25.25 0 00-.173-.15l-.06-.007H2.75a.75.75 0 01-.102-1.493L2.75 4h2.537z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Webshop = /*#__PURE__*/forwardRef(IconWebshop);

export default Webshop;
//# sourceMappingURL=Webshop.js.map
